var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2737.894,
    height: 338.859,
    viewBox: "0 0 2737.894 338.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    transform: "translate(-14041.327 14625.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M211.707,86.961c.3,95.56.74,9.059,0,165.622,137.878-.9,534.6-.427,1344.849-.555,710.112.27,1289.326.039,1392.895.062-.033-86.739.381-1.814-.039-86.969C2799.429,82.385,2589.238,43.695,2381.846,32.48c-77.762-4.209-156.485-4.915-233.737,1.722-153.826,13.245-294.934,54.864-440.959,85.356-261.014,54.451-552.724,73.348-817.243,24.65C676.975,105.063,431.96,13,211.707,86.961Z",
    transform: "translate(13829.62 -14539.419)",
    fill: "#fff",
    opacity: 0.314
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M211.707,116.812c.3,145,.74,13.746,0,251.312,137.878-1.365,534.6-.648,1344.849-.842,710.112.41,1289.326.06,1392.895.093-.033-131.617.381-2.752-.039-131.965C2799.429,109.868,2589.238,51.16,2381.846,34.144c-77.762-6.387-156.485-7.458-233.737,2.613-153.826,20.1-294.934,83.249-440.959,129.518-261.014,82.624-552.724,111.3-817.243,37.4C676.975,144.279,431.96,4.578,211.707,116.812Z",
    transform: "translate(13829.62 -14654.96)",
    fill: "#fff",
    opacity: 0.314
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.8807044af8898d009271a16329e35258.svg";
export { ForwardRef as ReactComponent };